import { FileSelectField, FormFieldV2 } from '@/components/custom/erp';
import type { DetailItemRow } from './hooks/useDetailItemRows';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
  rows: DetailItemRow[];
}

export const OtherTab = ({ formMode, rows }: Props) => {
  const customer = rows[0]?.ma_kh_data;

  return (
    <div className='flex flex-col gap-3 p-4'>
      <div className='flex items-center gap-2'>
        <Label className='w-32 min-w-32 text-left'>Mã đối tượng</Label>
        <FormFieldV2
          className='w-[250px] items-center'
          type='text'
          name='ma_kh'
          disabled={true}
          value={customer?.customer_code}
        />
        {customer?.customer_name && <span className='text-sm'>{customer.customer_name}</span>}
      </div>
      <div className='flex items-center gap-2'>
        <Label className='w-32 min-w-32 text-left'>Kèm theo</Label>
        <FormFieldV2 className='w-[250px] items-center' type='number' name='so_ct_goc' disabled={formMode === 'view'} />
      </div>

      <div className='flex items-center gap-2'>
        <Label className='w-32 min-w-32 text-left'>Chứng từ gốc</Label>
        <FormFieldV2
          className='w-[250px] items-center'
          type='text'
          name='dien_giai_ct_goc'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-2'>
        <Label className='w-32 min-w-32 text-left'>Tên ngân hàng</Label>
        <FormFieldV2 className='w-[250px] items-center' type='text' name='ten_nh' disabled={true} />
      </div>
    </div>
  );
};
